import { render, staticRenderFns } from "./Tiers.vue?vue&type=template&id=21ce8ef6"
import script from "./Tiers.vue?vue&type=script&lang=ts"
export * from "./Tiers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports